<template>
    <v-checkbox
        class="mt-0"
        v-model="saveByDefault"
        :label=label
        color="green darken-2"
        @click='handleSaveByDefault'
    ></v-checkbox>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "StepSaveByDefaultCheckbox",
        data() {
            return {
                saveByDefault: false,
            };
        },
        props: {
            selectedOption:{
                required:false,
            },
            stepId: {
                type: String,
                required: true,
            },
            label : {
                type: String,
                required: true,
            }
        },
        computed: {
            ...mapGetters(['isLocalstorageAvailable']),
            storageKey(){
                return this.$props.stepId ?`myHabiteo-studio-step-${this.$props.stepId}` : null;
            }
        },
        mounted(){
            if (this.isLocalstorageAvailable) 
                if (localStorage.getItem(this.storageKey)) 
                    this.saveByDefault = true;
        },
        methods: {
            handleSaveByDefault() {
                if (this.isLocalstorageAvailable)
                    if (this.saveByDefault) 
                        localStorage.setItem(this.storageKey, JSON.stringify(this.$props.selectedOption));
                    else 
                        localStorage.removeItem(this.storageKey);
                },
        },
        watch: {
            selectedOption(){
                this.saveByDefault = false;
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepSaveByDefaultCheckbox.vue